const list_mixin = {
    data() {
      return {
        key: '', //实体第几列
        matching_results: [], //实体匹配结果
      }
    },
    computed: {
      entity_keys() {
        return this.$store.state.entity_keys
      },
      time_keys() {
        return this.$store.state.time_keys
      },
      address_keys() {
        return this.$store.state.address_keys
      },
      round_keys() {
        return this.$store.state.round_keys
      }
    },
    methods: {
        dealList(arr_content)  { // 处理榜单数据
          let col_list = []
          let arr = []
          if(arr_content){
            let content = JSON.parse(arr_content)
            let content_c = content.splice(1, content.length)
            //组装对象数组 表格数据
            content_c.forEach((item, index) => {
              for(let key in {...item}){
                item['col'+ key] = item[key]
              }
              arr[index]  = {...item}
            })
            //组装表头
            content[0].forEach((item, index) =>{
              //列的类型 type
              let type = 0
              if(this.time_keys.includes(item)){
                type = 1 //排序
              }
              else if(this.address_keys.includes(item) || this.round_keys.includes(item)){
                type = 2 //筛选
              }
              else if(this.entity_keys.includes(item)){
                type = 3 //实体
                this.key = index 
              }else{
                type = 0 //普通类型
              }
              //获取某列数组去重
              let temp = [...new Set(arr.map(m => m[index]))]
              //获取筛选项 数组
              let temp_copy = []
              temp.forEach(a => {
                if(a){
                  let num = 0
                  num = arr.filter(i => i[index] == a).length
                  temp_copy.push({
                    text: a + '(' + num + ')',
                    value: a
                  })
                }
              })
              //组装表头
              col_list.push({
                name: item,
                temp_arr: temp_copy,
                type: type
              })
            })
          }
          return {
            col_list: col_list,
            arr: arr,
            n_key: this.key 
          }
        },
        dealListEntity(arr_content)  { // 处理榜单数据 实体
          let arr = []
          let e_index = ''
          if(arr_content){
            let content = JSON.parse(arr_content)
            let content_c = content.splice(1, content.length)
            //组装对象数组 表格数据
            content_c.forEach((item, index) => {
              arr[index]  = {...item}
            })
            content[0].forEach((i, i_index) =>{
              if(this.entity_keys.includes(i)){
                e_index = i_index
              }
            })
          }
          // console.log(arr)
          return {
            arr: arr.map(a => a[e_index]),
            n_key: this.key 
          }
        },
        //处理实体 跳转
        getResult(row, type_c) {
          let temp = this.matching_results.find(item => item.short_name == row[this.key])
          let url = ''
          if(type_c == '1'){ //动脉橙
            if(temp && temp.uid){
              let route = temp.type == '0' ? 'companyDetail' : temp.type == '1' ? 'orgDetail' : 'hospitalDetail'
              url =  'https://vbdata.cn/' + route + '/' + temp.uid
            }else{
              url = ''
            }
          }else if(type_c == '2'){ //官网
            url =  temp && temp.main_page ? temp.main_page : ''
          }
          return {
            url: url,
            description: temp && temp.description ? temp.description : ''
          }
        }
    }
}

const scroll_mixin = {
  methods: {
      //锚点监听
      listenerScroll(item, size = 0) {
        let top = document.documentElement.scrollTop || document.body.scrollTop  //滚动条的值
        let offset = $('.list-table').offset().top
        let footer = $('.footer').offset().top
        if(top >= offset - 80 ){
          $('.anchor').addClass('anchor-fixed')
          let bottom = top + window.innerHeight - footer + size
          if (bottom > - 1) {
              $('.' + item).css('bottom', (bottom + 20) + 'px')
          } else {
              $('.' + item).css('bottom', (size + 20) + 'px')
          }
        }else{
          $('.anchor').removeClass('anchor-fixed')
          $('.' + item).css('bottom', 0 + 'px')
        }
      }
  }
}

export { list_mixin, scroll_mixin }
